import { ChevronRight, ChevronLeft } from "lucide-react";
import { CardIconInspectionSearch } from "../../components/svg";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";

const ScrollableCardBlock = ({
  site,
  otherSites,
  cardContainerRef,
  scrollLeft,
  scrollRight,
  showLeftButton,
  showRightButton,
  expandedSite,
  setExpandedSite,
  cardWidth,
  cardHeight,
  title,
  isSplitScreen
}: any) => {

    useEffect(()=>{
        console.log("site", site)
    },[site])
    const getIconForStatus = (status: string) => {
        const safeStatus = status?.toLowerCase();
    
        switch (safeStatus) {
          case "total":
            return <CardIconInspectionSearch />;
          default:
            return <CardIconInspectionSearch />;
        }
      };

      const getIconBackgroundColor = (label: string, isTotal: boolean) => {
    if (isTotal) return "bg-white bg-opacity-20";
    switch (label) {
      case "Pass":
        return "bg-[#06D6A0]";
      case "Fail":
        return "bg-[#EF476F]";
      case "Overridden":
        return "bg-[#FFD166]";
      case "Pending":
        return "bg-[#FF8225]";
      case "In-Progress":
        return "bg-[#FFEB00]";
      case "Completed":
        return "bg-[#344CB7]";
      case "Negative":
        return "bg-[#EB3678]";
      case "Un-Verified":
        return "bg-[#C8ACD6]";
      case "Verified":
        return "bg-[#3FA2F6]";
      default:
        return "bg-gray-200";
    }
  };
  return (
    <div className="relative w-full mb-18">
        <h1 className="text-[2.5rem] text-io-black font-inter font-normal dark:text-io-white ml-[1rem]">{title}</h1>
      {showLeftButton && (
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-lg z-10"
        >
          <ChevronLeft size={24} />
        </button>
      )}

      <div
        className="overflow-x-auto scrollbar-hide px-2"
        ref={cardContainerRef}
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="flex flex-col gap-6">
          {/* 🔹 Main site cards */}
          <div className="flex flex-nowrap gap-4 justify-start w-full">
            {site?.cardsData?.map((card: any, index: number) => {
              const totalCards = site.cardsData.length;
              const maxWidthPercent = 100 / totalCards - 0.7;
              
              return (
                <div
                  key={index}
                  className={`flex flex-col items-start justify-center rounded-2xl shadow-md relative mb-4 flex-shrink-0 p-8 ${
                    index === 0
                      ? "bg-[#0078D4] text-white"
                      : "bg-[#F9FAFB] text-black"
                  }`}
                  style={{
                    minWidth: cardWidth,
                    height: cardHeight,
                    flexBasis: `${maxWidthPercent}%`,
                    maxWidth: `${maxWidthPercent}%`,
                  }}
                >
                  <div
  className={`flex ${
    isSplitScreen ? "flex-row items-center gap-6" : "flex-col"
  }`}
>
  {/* Icon */}
  <div
    className={`z-10 rounded-full flex items-center justify-center ${
      isSplitScreen
        ? "relative w-[64px] h-[64px] p-6"
        : "absolute top-8 left-6 w-[46px] h-[46px] p-5"
    }`}
    style={{
      backgroundColor:
        card.status === "Total"
          ? "rgba(255, 255, 255, 0.2)"
          : card.fontColor,
    }}
  >
    {card.status.toLowerCase() === "total" ? (
      getIconForStatus(card.status)
    ) : (
      <img
        src={card.imageUrl}
        alt={card.status}
        className={`object-contain ${
          isSplitScreen ? "w-10 h-10" : "w-6 h-6"
        }`}
        onError={(e) => {
          (e.target as HTMLImageElement).src = "/icons/default.png";
        }}
      />
    )}
  </div>

  {/* Text */}
  <div className={isSplitScreen ? "" : "mt-[75px]"}>
    <p
      className={`font-normal font-inter ${
        isSplitScreen ? "text-[4rem]" : "text-xl"
      }`}
    >
      {card.status}
    </p>
    <p
      className={`font-semibold font-[Albert Sans] capitalize pt-2 ${
        isSplitScreen ? "text-[4rem]" : "text-5xl"
      }`}
    >
      {card.value}
    </p>
  </div>
</div>

                </div>
              );
            })}
          </div>

          {/* 🔹 Other site accordions */}
          {otherSites?.map((site: any, index: number) => (
            <Accordion
              key={site.siteName}
              expanded={expandedSite === site.siteName}
              onChange={() =>
                setExpandedSite(
                  expandedSite === site.siteName ? null : site.siteName
                )
              }
              sx={{
                backgroundColor: "#f5f5f5",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxShadow: "none",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                sx={{
                  backgroundColor: "#D9E1E8",
                  borderBottom: "1px solid #ccc",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "56px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  px: "16px",
                }}
              >
                <ExpandMoreIcon
                  sx={{
                    fontSize: "16px",
                    transform:
                      expandedSite === site.siteName
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
                <p className="text-2xl font-semibold">{site.siteName}</p>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                <div className="flex flex-nowrap gap-4 justify-start">
                  {site.cardsData.map((card: any, i: number) => (
                    <div
                      key={i}
                      className={`w-[151px] h-[163px] p-11 flex flex-col flex-shrink-0 items-start justify-center rounded-2xl shadow-[0_8px_16px_rgba(0,0,0,0.1)] relative mb-4 ${
                        i === 0
                          ? "bg-[#0078D4] text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <div
                        className={`w-[46px] h-[46px] p-6 rounded-full flex items-center justify-center absolute top-8 left-10 ${getIconBackgroundColor(
                          card.status,
                          card.status === "Total"
                        )}`}
                      >
                        {getIconForStatus(card.status)}
                      </div>
                      <div className="mt-[75px]">
                        <p className="text-xl font-normal font-inter">
                          {card.status}
                        </p>
                        <p className="text-5xl font-semibold font-[Albert Sans] leading-[100%] tracking-[0%] capitalize pt-6">
                          {card.value}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      {showRightButton && (
        <button
          onClick={scrollRight}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-lg z-10"
        >
          <ChevronRight size={24} />
        </button>
      )}
    </div>
  );
};
export default ScrollableCardBlock;